import React, { useState, useEffect, Fragment } from 'react';
import { toInteger } from 'lodash';

import {
  Container,
  makeStyles,
  Box,
  Card,
  CardContent
} from '@material-ui/core';

import agm from '../../services/agm';

import { BsPrinter } from "react-icons/bs";

import Page from 'src/components/Page';

import Alerts from '../../utils/alerts';

import Toolbar from './Toolbar';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    width: 32,
    height: 32
  },
  grid: {
    marginTop: 10
  },
  button: {
    fontWeight: theme.typography.fontWeightMedium,
    textTransform: 'none',
    width: '100%'
  },
  link: {
    marginTop: 5
  }
}));

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultResultColumns = [];

const defaultEmptyMessage = "Nenhum Relatório Foi Encontrado.";

const defaultfullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_HIDE,
  delete: LEVEL_ACCESS_HIDE,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_ENABLED,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_HIDE,
  delete: LEVEL_ACCESS_HIDE,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_ENABLED,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultResultModes = [defaultfullMode, defaultCompactMode];

var option1 = { id: 1, name: "Detalhado" };
var option2 = { id: 2, name: "Consolidado" };

var option3 = { id: 1, name: "Agrupado por Compartimento" };
var option4 = { id: 2, name: "Ordenado por Categoria" };

var option5 = { id: 1, name: "Completo" };
var option6 = { id: 3, name: "Por Data" };

var option7 = { id: 1, name: "Agrupado Por Compartimento" };
var option8 = { id: 2, name: "Agrupado Por Produto" };

var option10 = { id: 1, name: "Entradas" };
var option11 = { id: 2, name: "Material Utilizado" };
var option12 = { id: 3, name: "Saldo" };

var estoqueAtualFiles = ["Estoque Atual Compartimento.pdf", "Estoque Atual Categoria.pdf"];
var estoquePeriodoFiles = ["Entradas Periodo.pdf", "Baixas Periodo.pdf", "Saldo Periodo.pdf"];
var ocorrenciasAberturaFiles = ["Ocorrências Abertura.pdf"];
var orcamentosFiles = ["Orçamentos.pdf"];
var requisicoesFiles = ["Requisicões.pdf"];

var defaultVisions = [
  { id: 1, name: 'Estoque Atual', refine: 1, history: 0, files: estoqueAtualFiles, endpoint: '/estoqueatual', options: [option3, option4], export: false },
  { id: 16, name: 'Estoque por Periodo', refine: 1, history: 1, files: estoquePeriodoFiles, endpoint: '/estoqueperiodo', options: [option10, option11, option12], export: false },
  // { id: 16, name: 'Lançamentos no Estoque', refine: 1, history: 1, file: 'Lançamentos Estoque.pdf', endpoint: '/estoquelancs', options: [option7, option8], export: false },
  // { id: 13, name: 'Material Utilizado por Nota e Lançamento', refine: 1, history: 1, file: 'Lançamentos Nota.pdf', endpoint: '/materiaisnota', options: [option1], export: false },
  // { id: 9, name: 'Material Utilizado por Ocorrência', refine: 1, history: 1, file: 'Utilização Ocorrencia.pdf', endpoint: '/materiaiscorrencia', options: [option1], export: false },
  // { id: 2, name: 'Material Utilizado por Tipo de Ocorrência', refine: 1, history: 1, file: 'Utilização Tipo.pdf', endpoint: '/materiaistpcorrencia', options: [option2], export: false },
  // { id: 3, name: 'Material Utilizado por Tipo de Unidade', refine: 1, history: 1, file: 'Utilização Unidade.pdf', endpoint: '/materiaistpunidade', options: [option2], export: false },
  // { id: 4, name: 'Material Utilizado por Técnico', refine: 1, history: 1, file: 'Utilização Técnico.pdf', endpoint: '/materiaistecnico', options: [option2], export: false },
  // { id: 5, name: 'Material Utilizado por Centro de Custo', refine: 1, history: 1, file: 'Utilização CCusto.pdf', endpoint: '/materiaisccusto', options: [option2], export: false },
  { id: 6, name: 'Ocorrências por Data de Abertura', refine: 1, history: 1, files: ocorrenciasAberturaFiles, endpoint: '/ocorrenciasabertura', options: [option1], export: false },
  // { id: 10, name: 'Ocorrências por Equipe', refine: 1, history: 1, file: 'Ocorrências Equipe.pdf', endpoint: '/ocorrenciasequipe', options: [option1], export: false },
  // { id: 12, name: 'Ocorrências por Tipo de Atendimento', refine: 1, history: 1, file: 'Ocorrências Atendimento.pdf', endpoint: '/ocorrenciasatend', options: [option1], export: false },
  // { id: 14, name: 'Ocorrências com Ações Abertas', refine: 1, history: 1, file: 'Ocorrências Ações.pdf', endpoint: '/ocorrenciasacao', options: [option1], export: false },
  // { id: 7, name: 'Preventivas por Data de Abertura', refine: 1, history: 1, file: 'Preventivas.pdf', endpoint: '/preventivas', options: [option1], export: true },
  { id: 8, name: 'Orçamentos por Contrato e Data de Criação', refine: 1, history: 1, files: orcamentosFiles, endpoint: '/orcamentos', options: [option2], export: false },
  // { id: 11, name: 'Extrato Caixinha', refine: 1, history: 0, file: 'Extrato Caixinha.pdf', endpoint: '/extratocaixinha', options: [option5, option6], export: false },
  { id: 15, name: 'Requisições de Material por Técnico', refine: 1, history: 1, files: requisicoesFiles, endpoint: '/requisicoes', options: [option2], export: false },
];

const defaultItem = {
  id: null,
  title: null,
  file: null
}

const defaultState = {
  loaded: false,
  records: 10,
  pages: 0,
  page: 0,
  count: 0,
  rows: []
}

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const defaultFilter = {
  pagina: 0,
  registros: 10,
  inicio: defaultStartDateTime,
  final: defaultEndDateTime,
  opcao: defaultVisions[0].options[0].id,
  palavrachave: '',
  visao: defaultVisions[0]
}

const Products = () => {

  const classes = useStyles();

  const [item, setItem] = useState(defaultItem);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});
  const [filter, setFilter] = useState(defaultFilter);
  const [vision, setVision] = useState(defaultVisions[0]);
  const [resultModes, setResultModes] = useState(defaultResultModes);
  const [selectedMode, setSelectedMode] = useState(MODE_FULL);

  const [option, setOption] = useState(defaultFilter.opcao);
  const [state, setState] = useState(defaultState);

  const openCreation = (item) => {
    setState(defaultState);
    agm.post('/relatorios' + vision.endpoint, { filtro: filter }, {}).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: "Erro ao Atualizar o Relatório.", detail: error.message });
      setOpenAlert(true);
    })
  }

  const openExport = async (item) => {
    setState(defaultState);
    await agm.post('/relatorios' + vision.endpoint, { filtro: filter }, {}).then((response) => {
      if (!response.data.error) {
        const link = window.document.createElement('a');
        var url = process.env.REACT_APP_AGM_ENDPPOINT + '/exports/' + vision.file.replace("pdf", "xlsx");
        link.setAttribute('download', vision.file.replace("pdf", "xlsx"));
        link.href = url;
        window.document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        refreshItems();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: "Erro ao Atualizar o Relatório.", detail: error.message });
      setOpenAlert(true);
    })
  }

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const refreshItems = () => {
    agm.post('/relatorios/historico', { filtro: filter }, {}).then((response) => {
      setState({
        loaded: true,
        pages: toInteger((response.data.count / filter.registros)) + 1,
        page: filter.pagina,
        count: response.data.count,
        rows: response.data.rows
      });
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: "Erro ao Recuperar o Relatório.", detail: error.message });
      setOpenAlert(true);
    })
  }

  useEffect(() => {
    refreshItems();
  }, []);

  const changeFilter = (startDateTime, endDateTime, vision, keyword, page, rows, option) => {
    var value = {
      pagina: page,
      registros: rows,
      inicio: startDateTime,
      final: endDateTime,
      palavrachave: keyword,
      visao: vision,
      opcao: option
    };
    setVision(vision);
    setFilter(value);
    setOption(option);
    agm.post('/relatorios/historico', { filtro: value }, {}).then((response) => {
      setState({
        loaded: true,
        pages: toInteger((response.data.count / value.registros)) + 1,
        page: value.pagina,
        count: response.data.count,
        rows: response.data.rows
      });
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: "Erro ao Recuperar o Relatório.", detail: error.message });
      setOpenAlert(true);
    })
  }

  return (
    <Page
      className={classes.root}
      title="Produtos"
    >
      <Container maxWidth={false}>

        <Toolbar
          icon={BsPrinter}
          item={defaultItem}
          resultset={state}
          resultModes={resultModes}
          vision={vision}
          visions={defaultVisions}
          selectedMode={selectedMode}
          openCreation={openCreation}
          changeFilter={changeFilter}
          openExport={openExport}
        />

        <Alerts message={message}
          open={openAlert}
          closeAlert={closeAlert} />

        <Box mt={2}>
          <Card>
            <CardContent>
              {(state && state.rows) &&
                state.rows.map((item) => (
                  <Fragment>
                    <iframe src={process.env.REACT_APP_AGM_ENDPPOINT + '/reports/' + item.visao.files[item.opcao - 1]} width="100%" height={540} />
                  </Fragment>
                ))}
            </CardContent>
          </Card>
        </Box>

      </Container>

    </Page>
  );
};

export default Products;
